export const RESET_USER_PROFILE_FORM = 'RESET_USER_PROFILE_FORM';

export function resetUserProfileForm() {
  return {type: RESET_USER_PROFILE_FORM};
}



// WEBPACK FOOTER //
// ./app/features/userProfile/actions/resetUserProfileForm.js